import { useMemo } from 'react';

import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns';

import { MultiToggleGroup } from './multi-toggle-group';

const ALL_WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];

const REFERENCE_MONDAY = new Date(2026, 0, 5);

export const getWeekdayLabels = (): Record<number, string> => {
  const start = startOfWeek(REFERENCE_MONDAY, { weekStartsOn: 1 });
  const end = endOfWeek(REFERENCE_MONDAY, { weekStartsOn: 1 });
  const days = eachDayOfInterval({ start, end });
  return Object.fromEntries(days.map((day, index) => [index + 1, format(day, 'EEE')]));
};

export type WeekdayPickerProps = {
  defaultValue?: number[];
  value?: number[];
  onChange: (days: number[]) => void;
  minSelectedTooltip?: string;
};

export const WeekdayPicker = ({
  defaultValue,
  value,
  onChange,
  minSelectedTooltip,
}: WeekdayPickerProps) => {
  const labels = useMemo(getWeekdayLabels, []);

  return (
    <MultiToggleGroup.Root
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      fullWidth
      minSelected={1}
    >
      {ALL_WEEKDAYS.map((day) => (
        <MultiToggleGroup.Button
          key={day}
          value={day}
          text={labels[day]}
          minSelectedTooltip={minSelectedTooltip}
        />
      ))}
    </MultiToggleGroup.Root>
  );
};
